import styled from 'styled-components';

// colors
import {red} from '@drivesally/sally-ui/lib/libs/colors';

const LoadingContainer = styled.div`
  width: 100%;
  height: ${({full}) => (full ? '100%' : '100px')};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 28px;
  color: ${red};
`;

export default LoadingContainer;
